module.exports = __webpack_public_path__ + "~@/assets/img/4_share.a24db28a.png";